import React, { Children } from 'react';

import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import './NavbarPanelFooter.sass';

import { buildTestid } from '../../../lib/utils';
import { useNavbarContext } from '../useNavbarContext';

export interface NavbarPanelFooterProps extends
  WithDataTestid,
  WithClassNameProp {
  children?: React.ReactNode;
  viewer?: React.ReactNode;
}

const displayName = 'NavbarPanelFooter';
const testid = buildTestid(displayName);

function NavbarPanelFooter({
  viewer = undefined,
  children = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: NavbarPanelFooterProps): React.JSX.Element {
  const { type } = useNavbarContext();
  return (
    <div
      {...testid(dataTestId)}
      className={cn('NavbarPanelFooter', {
        [`NavbarPanelFooter_${type}`]: type,
      }, className)}
    >
      <div
        className={cn('NavbarPanelFooter__Viewer')}
        {...testid('Viewer', dataTestId)}
      >
        {viewer}
      </div>
      <div
        {...testid('Buttons', dataTestId)}
        className={cn('NavbarPanelFooter__Buttons')}
      >
        {Children.map(children, (child, idx): React.ReactNode => {
          if (Children.count(children) > 1 && idx === Children.count(children) - 1) {
            return (
              <React.Fragment>
                <div className={cn('NavbarPanelFooter__Divider')} />
                {child}
              </React.Fragment>
            );
          }
          return child;
        })}
      </div>
    </div>
  );
}

NavbarPanelFooter.displayName = displayName;

export { NavbarPanelFooter };
